'use strict';

var web_generic_arrowBack_12 = require('./12.js');
var web_generic_arrowBack_16 = require('./16.js');
var web_generic_arrowBack_20 = require('./20.js');
var web_generic_arrowBack_24 = require('./24.js');
require('react');



exports.Svg12 = web_generic_arrowBack_12.default;
exports.Svg16 = web_generic_arrowBack_16.default;
exports.Svg20 = web_generic_arrowBack_20.default;
exports.Svg24 = web_generic_arrowBack_24.default;
//# sourceMappingURL=index.js.map
